import React from 'react';
import '../css/Portada.css';

// Imagen principal
import portada01 from '../img/Portada/Portada01.jpg';

function Portada() {
    return (
        <section className="esc-portada">

            {/* Imagen de fondo */}
            <img
                src={portada01}
                alt="Escuela Nueva Zelandia"
                className="esc-portada-imagen"
            />

            {/* Capa oscura con degradado */}
            <div className="esc-portada-overlay"></div>

            {/* Marca de agua */}
            <div className="esc-portada-watermark"></div>

            {/* Contenido */}
            <div className="esc-portada-contenido">

                <span className="esc-portada-bienvenida">
                    Bienvenidos a la
                </span>

                <h1 className="esc-portada-titulo">
                    Escuela Nueva Zelandia
                </h1>

                <div className="esc-portada-linea"></div>

                <h2 className="esc-portada-subtitulo">
                    Independencia
                </h2>

                <p className="esc-portada-descripcion">
                    Educación Pública de Calidad
                </p>

            </div>

            {/* Flecha indicando que existe más contenido */}
            <div className="esc-portada-scroll">

                <span></span>

            </div>

        </section>
    );
}

export default Portada;

